<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="SP"> </p>
<section epub:type="note">
<p class="FM-Head-fmh-last" id="fm01"><span aria-label="ix" id="pg_ix" role="doc-pagebreak"><span href="#/xhtml/contents#c_fm01" title="Link target outside of Sample">NOTE ON SPELLING AND EXPRESSIONS</span></span></p>
<p class="FM-Text-No-Indent-fmtx1">As Cond<span class="fm-text-no-indent-fmtx1-_span-accent-characters-acc">é</span> Nast ran a truly international business, some correspondence—particularly with his British counterparts—appears in British English in the book. For example, I have used the British edition of <i>Always in Vogue</i> by Edna Woolman Chase as a primary source book, so all quotations from it will be spelled in British English. I have not changed any British spelling, punctuation, or expressions into American English but have provided a “translation” by way of a footnote only if I believed one was required. Similarly, there are a number of spelling errors and abbreviations in some letters, which I have not corrected other than to add letters or words [in brackets] or as a footnote for ease of understanding. Letters by Michel de Brunhoff are written in English and have the Frenchman’s grammatical errors intact. To handle this any other way, in my opinion, would detract from the flow of the letters with a ubiquitous use of [<i>sic</i>], while adding nothing to the context and, for many, possibly diminishing their enjoyment of those I’ve included. I also refer to what we call World War I as the Great War, in the parlance of the day, until its sequel—World War II—made it possible to add a number this most devastating of conflicts. Many of the French expressions used have been incorporated into English, but for <span aria-label="x" id="pg_x" role="doc-pagebreak">those that haven’t, I provide a translation on the same page. The various dances mentioned in the book are called by their proper names, but to find out how they can be told apart, or indeed how to dance them, you will need to consult old films available online.</span></p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm01.vue?3ec2b572